import { AppShell } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { PropsWithChildren } from 'react';
import { BottomNav } from './bottom-nav';
import { Footer, FooterProps } from './footer';
import { Header, HeaderProps } from './header';
import styles from './styles.module.css';
import { TopNav, TopNavFor } from './top-nav';

export type PrimaryLayoutProps = (
	| {
			header: HeaderProps;
			topNav?: TopNavFor;
	  }
	| {
			header?: never;
	  }
) & {
	footer?: FooterProps;
	bottomNav?: 'home';
};

// TODO: Make these defined in just one place
const headerHeight = 85;
const topNavHeight = 60;
const footerHeight = 104;
const bottomNavHeight = 83;

export const PrimaryLayout = (props: PropsWithChildren<PrimaryLayoutProps>) => {
	const { height } = useViewportSize();

	const fixedHeaderHeight = props.header
		? props.topNav
			? topNavHeight + headerHeight
			: headerHeight
		: 0;
	const fixedFooterHeight = props.footer
		? props.bottomNav
			? bottomNavHeight + footerHeight
			: footerHeight
		: props.bottomNav
			? bottomNavHeight
			: 0;
	return (
		<AppShell
			header={{ height: fixedHeaderHeight }}
			footer={{ height: fixedFooterHeight }}
			className={styles.appShell}
			style={{ minHeight: height }}
		>
			{props.header && (
				<div>
					<Header {...props.header} />
					{props.topNav && <TopNav forPage={props.topNav} />}
				</div>
			)}
			<div className={styles.content}>{props.children}</div>
			{(props.footer || props.bottomNav) && (
				<div>
					{props.footer && <Footer {...props.footer} />}
					{props.bottomNav && <BottomNav />}
				</div>
			)}
		</AppShell>
	);
};
